// @flow
import ContrastColorUpdater from "../../helper/ContrastColorUpdater";
import useThemeStylesheet from "../../hooks/useThemeStylesheet";

const OpelTheme = props => {
	useThemeStylesheet(() => import("./opel.lazy.scss"));
	return <>
		{props.children}
		<ContrastColorUpdater/>
	</>;
};

export default OpelTheme;
